/** Synced with apps/mobile gluestack-ui-provider/config.ts brand tokens */
export const BrandColors = {
  purple: {
    400: '#B39CEC',
    500: '#A286E9',
    800: '#514172',
    950: '#281E37',
  },
  turquoise: {
    200: '#BAECFE',
    500: '#59D2FE',
    700: '#4399B3',
  },
  green: {
    400: '#D6ED9C',
    500: '#CDE986',
  },
  orange: {
    500: '#FE8458',
  },
  yellow: {
    200: '#FFD02B',
    500: '#FFD321',
  },
  purple950Rgb: { r: 40, g: 30, b: 55 },
} as const;
